import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Table, TableBody, TableHeader, TableHeading, TableRow } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import { GroupInfo } from 'types/policyService';
import DateRange from 'components/common/general/DateRange';
import { createStyles } from './styles';
import InsightsTableRow from './InsightsTableRow';

const InsightsTable = observer((): JSX.Element => {
  const classes = createStyles();

  const {
    insightsStore: { loading, groupsInfo, getGroupsInfoByDate },
  } = useRootStore();

  const convertedGroupsInfo = groupsInfo.map((info) => toJS(info)).slice();

  const rowsList = convertedGroupsInfo
    .sort((a, b) => (a.groupName.toLowerCase() > b.groupName.toLowerCase() ? 1 : -1))
    .map((info: GroupInfo): JSX.Element => {
      return <InsightsTableRow key={`${info.groupId}-${info.effectiveDate}`} groupInfo={info} />;
    });

  const updateTableByDateRange = (dateFrom: string, dateTo: string, fullAgencyView: boolean): void => {
    void getGroupsInfoByDate(dateFrom, dateTo, fullAgencyView);
  };

  return (
    <div className={classes.insightsContent}>
      <div className={classes.infoWrapper}>
        <DateRange updateTableByDateRange={updateTableByDateRange} />
      </div>
      <p className={classes.groupsCountText}>
        Total Groups Count:<b className={classes.groupsCount}>{convertedGroupsInfo.length}</b>
      </p>
      <div className={classes.tableWrapper}>
        <Table loading={loading} totalElements={convertedGroupsInfo.length} className={classes.table} showScrollShadows>
          <TableHeader className={classes.tableHeader}>
            <TableRow>
              <TableHeading className={classes.tableHeading}>Group Name</TableHeading>
              <TableHeading className={classes.tableHeading}>Agency Name</TableHeading>
              <TableHeading className={classes.tableHeading}>AoR Name</TableHeading>
              <TableHeading className={classes.tableHeading}>Effective Date</TableHeading>
              <TableHeading className={classes.tableHeading}>Product Line</TableHeading>
              <TableHeading className={classes.tableHeading}>Submitted By</TableHeading>
              <TableHeading className={classes.tableHeading}>Submitted Date</TableHeading>
            </TableRow>
          </TableHeader>
          <TableBody className={classes.tableBody}>{rowsList}</TableBody>
        </Table>
      </div>
    </div>
  );
});

export default InsightsTable;
